import appToast from './appToast';
import {
  applyValidationErrorsToForm,
  extractApiErrorPayload,
  flattenValidationErrors,
  formatApiError,
  getApiErrorMessages,
} from './apiErrorMessages';

export {
  applyValidationErrorsToForm,
  extractApiErrorPayload,
  flattenValidationErrors,
  formatApiError,
  getApiErrorMessages,
};

export function handleApiValidationError(error, { form, fallbackMessage, showToast = true } = {}) {
  const data = extractApiErrorPayload(error);
  const fieldErrors = data?.errors;
  const allMessages = getApiErrorMessages(error, fallbackMessage ?? 'Validation failed');

  applyValidationErrorsToForm(form, fieldErrors);

  if (showToast) {
    appToast.error(allMessages.join(' • '));
  }

  return { messages: allMessages, summary: allMessages[0], fieldErrors };
}

export function showApiError(error, { form, fallbackMessage, showToast = true } = {}) {
  return handleApiValidationError(error, { form, fallbackMessage, showToast });
}
